<template>
  <div id="user" v-show="showLogin() && $route.path !== '/'" class="top-right">
    <img src="@/assets/img/avatar.svg?data" class="avatar" alt="Avatar" /> {{ showName() }}
    <button @click="logOut()" class="btn btn-sm btn-primary">Logga ut</button>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'

export default {
  name: 'user',
  methods: {
    showLogin () {
      return this.$store.getters.getLogin || sessionStorage.getItem('userLoggedIn')
    },
    showName () {
      return this.$store.getters.getName || sessionStorage.getItem('userFullName')
    },
    logOut () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      this.$store.commit('setLogin', false)
      this.$store.commit('setName', null)
      var cookies = localStorage.getItem('vue-cookie-accept-decline-cookies')
      var access = localStorage.getItem('access')
      var pharmacy = localStorage.getItem('pharmacy')
      localStorage.clear()
      sessionStorage.clear()
      if (cookies) localStorage.setItem('vue-cookie-accept-decline-cookies', cookies)
      if (access) localStorage.setItem('access', access)
      if (pharmacy) localStorage.setItem('pharmacy', pharmacy)
      loader.hide()
      window.location.href = window.location.origin
    },
    handleScroll () {
      if (isMobile && this.showLogin()) {
        var top = document.body.scrollTop + document.documentElement.scrollTop === 0
        document.getElementById('user').style.display = top ? 'block' : 'none'
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.avatar {
  vertical-align: center;
}
.top-right {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  margin-right: 2em;
  margin-top: 5em;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue